// example
/*
var notifyEl = notification.notifyPopup('Test', 'Dies ist ein Test-Popup.', {
    modal: true,
    show: true,
    showClose: true,
    width: '500px',
    fullscreen: false,
    cssClass: 'loader',
    onClosed: callback,
    buttons: [{
        caption: 'OK',
        callback: notification.close
    }]
});
*/

var notification = {
    name: 'notification',
    transitionDuration: 0.35,

    init: function (onStarted) {
        onStarted();
    },

    // <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    // <span aria-hidden="true">&times;</span>
    // </button>

    notifyPopup: function (title, message, options) {
        options = options || {};
        var notifyEl = $('<div class="modal bootstrap-dialog type-light fade ' + (options.cssClass || '') + '" tabindex="-1" role="dialog" data-toggle="modal" style="background-color:rgba(25,25,25,0.4);">' +
            '  <div class="modal-dialog' + (options.fullscreen ? ' fullscreen' : '') + '" style="max-width:90%;max-height:100%;width:' + (options.width || '500px') + ';height:' + (options.height || 'auto') + ';margin:0 auto;">' +
            '    <div class="modal-content">' +

            '      <div class="modal-header">' +
            '        <div class="bootstrap-dialog-header">' +
            '          <div class="bootstrap-dialog-title">' + (title || '&nbsp;') + '</div>' +
            '            ' + ((options.showClose !== false) ? '<div class="bootstrap-dialog-close-button"><button class="close" aria-label="close">×</button></div>' : '') +
            '        </div>' +
            '      </div>' +

            '      <div class="modal-body">' +
            '        <span class="message">' + message + '</span>' +
            '      </div>' +
            '      <div class="modal-footer">' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>');

        if (options.spinner || false === true) {
            var notifyBody = notifyEl.find('.modal-body');
            notifyBody.startProcess();
        }
        if ((options.show || true) === true) {
            notification.show(notifyEl);
        }
        if (options.onClosed != null) {
            notifyEl.on('closed', options.onClosed);
        }
        notifyEl.find('.modal-header .close').on('click', function () {
            notification.close(notifyEl);
        });
        $.each(options.buttons || [], function (i, btn) {
            notification.addButton(notifyEl, btn);
        });
        return notifyEl;
    },

    show: function (notifyEl) {
        $('body').append(notifyEl).addClass('modal-open');
        notifyEl.addClass('show');
    },

    insertContent: function (notifyEl, content) {
        var notifyBody = notifyEl.find('.modal-body');
        notifyBody.html(content);
    },

    /**
     * @param notifyEl
     * @param buttonOptions {} { caption, callback, cssClass }
     */
    addButton: function (notifyEl, buttonOptions) {
        var btn = $('<button class="btn ' + (buttonOptions.cssClass || 'btn-default') + '">' + (buttonOptions.caption || 'Knopf') + '</button>');
        notifyEl.find('.modal-footer').append(btn);
        btn.on('click', function () {
            var result = buttonOptions.callback(notifyEl, btn);
            if (result === true) {
                notification.close(notifyEl);
            }
        });
    },

    close: function (notifyEl, onClosed) {
        notifyEl.removeClass('show');
        setTimeout(function () {
            notifyEl.hide().remove();
            $(notifyEl).trigger('closed');
            if (onClosed != null) onClosed();
        }, notification.transitionDuration * 1000);
    }

};

window.notification = notification;
